import { Injectable } from '@angular/core';

declare let sessionStorage: any;

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  getItem(keyName: string) {
    return sessionStorage.getItem(keyName);
  }

  removeItem(keyName: string) {
    return sessionStorage.removeItem(keyName);
  }

  setItem(keyName: string, value: any) {
    return sessionStorage.setItem(keyName, value);
  }
}
